function workload(players, max_players) {
    let one_p = max_players / players;
    return 100 / one_p;
}

export { workload };
